import React, { useEffect, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { MdOutlineClose } from "react-icons/md";
import { IoCopyOutline } from "react-icons/io5";
const recaptchaRef = React.createRef();
import { useMutation } from "react-query";
import fetcher from "../../src/dataProvider";
import accessStyle from "./styles";
import {
  Box,
  Typography,
  Link,
  Modal,
  List,
  ListItem,
  Button,
} from "@mui/material";
import SocialShareComponent from "../Buttons/socialShareReferral";
import {
  RECAPTCHA_SITE_KEY,
  GEOLOCATION_URL,
  WEB_URL,
  API_BASE_URL,
  DISCORD_URL,
} from "../../src/constant/appConstants";
import { useSelector, useDispatch } from "react-redux";
import { isEmpty, result } from "lodash";
import eventBus from "../../util/eventBus";
import { setUserDetail } from "../../src/redux/actions";
import auth from "../Layout/util/auth";
import TagManager from "react-gtm-module";
import { setUserData } from "../../src/redux/slices/user";

const styles = {
  headingText: {
    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: "600",
    fontSize: "28px",
    lineHeight: "34px",
    color: "black",
    textTransform: "capitalize",
  },
  descriptionText: {
    fontFamily: "Inter",
    fontstyle: "normal",
    fontWeight: "400",
    fontSize: "16px",
    lineHeight: "19px",
    textAlign: "center",
    fontFeatureSettings: "'cpsp' on",
    color: "rgba(0, 0, 0, 0.75)",
  },
  offerText: {
    margin: "auto",
    marginLeft: "8px",
    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "12px",
    lineHeight: "16px",
    color: "#000000",
  },
  offerTextBox: {
    width: "130px",
    height: "36px",
    position: "relative",
    marginLeft: "8px",
  },
  offerIconBox: {
    position: "relative",
    background: "rgba(0, 0, 0, 0.9)",
    border: "1px solid #E1CAF2",
    width: "34px",
    height: "34px",
    borderRadius: "8px",
    margin: "0px",
    padding: "0px",
    float: "left",
  },
  offerIcon: {
    width: "24px",
    height: "auto",
    position: "relative",
    float: "left",
    margin: "12px 0px 0px 6px",
  },
  offerContainer: {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  signupError: {
    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "21px",
    color: "red",
    marginTop: "15px",
  },
  rankContainer: {
    overflow: "hidden",
    position: "relative",
    width: "160px",
    height: "160px",
    margin: "30px auto 0px",
    borderRadius: "80px",
    borderWidth: "3px",
    borderColor: "red",
    background: "linear-gradient(to right, #E14084, #3454FA , #54B5BB)",
  },
  rankContainerInside: {
    width: "154px",
    height: "154px",
    background: "#fff",
    borderRadius: "79px",
    margin: "3px 0px 0px 3px",
  },
  rankHeadingText: {
    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: "600",
    fontSize: "16px",
    linHeight: "19px",
    margin: "45px 0px 0px 0px",
    color: "rgba(0, 0, 0, 0.9)",
    float: "left",
  },
  modalCloseButton: {
    cursor: "pointer",
    position: "relative",
    float: "right",
  },
  rankText: {
    position: "relative",
    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: "700",
    fontSize: "36px",
    linHeight: "44px",
    margin: "0px 0px 0px 32px",
    color: "rgba(0, 0, 0, 0.9)",
    float: "left",
    textAlign: "center",
    background: "yellow",
    textTransform: "uppercase",
    background:
      "-webkit-linear-gradient(45deg, #E14084 3.73%, #3454FA 53.09%, #54B5BB 96.58%)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  },
  waitListDescription: {
    width: "100%",
    maxWidth: "671px",
    position: "relative",
    margin: "20px auto 0px",
  },
  waitListText: {
    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: "600",
    fontSize: "18px",
    lineHeight: "27px",
    color: "rgba(0, 0, 0, 0.75)",
    textAlign: "center",
  },
  urlContainer: {
    padding: "2px 10px",
    maxWidth: "500px",
    width: "370px",
    height: "36px",
    border: "1px dashed rgba(0, 0, 0, 0.9)",
    borderRadius: "10px",
    position: "relative",
    margin: "24px auto 30px",
    display: "flex",
    alignItems: "center",
    "@media(max-width:480px)": {
      "& p": {
        fontSize: "12px",
      },
    },
  },
  bottomLink: {
    color: "#E14084",
    display: "block",
    marginTop: "10px",
    textAlign: "center",
  },
  urlText: {
    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: "400",
    fontSize: "14px",
    linHeight: "17px",
    color: "#E14084",
    textAlign: "center",
    whiteSpace: "nowrap",
  },
  copyToClipboardContainer: {
    width: "45px",
    justifyContent: "flex-end",
    alignItems: "flex-end",
    display: "flex",
    marginLeft: "10px",
  },
  copyToClipboardButton: {
    cursor: "pointer",
    justifyContent: "flex-end",
    alignItems: "flex-end",
    display: "flex",
  },
  copied: {
    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: "400",
    fontSize: "14px",
    linHeight: "17px",
    color: "#E14084",
    textAlign: "center",
  },
  socialButtonsContainer: {
    position: "relative",
    margin: "0 auto",
    display: "block",
    textAlign: "center",
  },
  dashline: {
    width: "449px",
    margin: "28px auto 19px",
    border: "1px solid rgba(0, 0, 0, 0.1)",
  },
  bottomText: {
    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: "400",
    fontSize: "14px",
    linHeight: "21px",
    color: "rgba(0, 0, 0, 0.75)",
    textAlign: "center",
  },
  offerContainerBox: {
    position: "realtive",
    width: "703px",
    height: "101px",
    margin: "30px 0px 0px 54px",
    background: "url('/images/icons/bgEarlyAccessOffer.png')",
    borderRadius: "10px",
    color: "white",
    p: 4,
    padding: "0",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    alignItems: "center",
    display: "flex",
    overflow: "hidden",
  },
  earlyAccessBox: {
    width: "176.78px",
    height: "172px",
    background: "linear-gradient(92deg, #626FD3 -6.99%, #8729BA 123.11%)",
    marginLeft: "-62px",
    borderRadius: "86px",
    overflow: "hidden",
  },
  earlyAccessText: {
    fontFamily: "Inter'",
    fontStyle: "normal",
    fontWeight: "700",
    fontSize: "18px",
    lineHeight: "22px",
    margin: "56px 0px 0px 70px",
  },
  limitedOfferContainer: {
    width: "100%",
    height: "16px",
    background: "linear-gradient(90.78deg, #B237F6 3.91%, #E94177 96.03%)",
    alignItems: "center",
    display: "flex",
    marginTop: "10px",
  },
  limitedOfferText: {
    fontFamily: "Inter'",
    fontStyle: "normal",
    fontWeight: "600",
    fontSize: "10px",
    margin: "0px 0px 0px 62px",
    lineHeight: "12px",
    paddingLeft: "8px",
  },
  buttonTitle: {
    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: "600",
    fontSize: "16px",
    lineHeight: "19px",
    color: "#FFFFFF",
    textTransform: "none",
  },
  signupErrorContainer: {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  firstOfferLogoContainer: {
    width: "34px",
    height: "34px",
    background: "rgba(0, 0, 0, 0.9)",
    position: "relative",
    borderRadius: "8px",
  },
  secondOfferLogoContainer: {
    width: "34px",
    height: "34px",
    background: "#D4403A",
    border: "1px solid #E1CAF2",
    position: "relative",
    borderRadius: "8px",
  },
  secondLogo: {
    width: "23px",
    height: "auto",
    position: "relative",
    float: "left",
    margin: "6px 5px 6px 5px",
  },
  thirdOfferContainer: {
    width: "34px",
    height: "34px",
    background: "url(/images/icons/matic.png)",
    position: "relative",
    borderRadius: "8px",
  },
  boxContainer: {
    position: "relative",
    maxWidth: "812px",
    width: "100%",
    height: "auto",
    padding: "20px",
    background: "#FFF",
    borderRadius: "20px",
    color: "white",
    boxShadow: 24,
    p: 4,
    padding: "0",
    margin: "auto",
  },
};

const ReferAndEarn = (props) => {
  const [open, setOpen] = useState(false);
  const handleOpen1 = () => setOpen(true);
  const handleClose1 = () => setOpen(false);
  const { profile, id } = useSelector((state) => state.user);
  const [show, setShow] = useState(props.open);
  const [email, setEmail] = useState("");
  const [formErrors, setFormErrors] = useState({});
  const [location, setLocation] = useState("");
  const [user, setUser] = useState(auth);

  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    getUserLocation();
  }, []);

  const handleClose = () => {
    setEmail("");
    setFormErrors({});
    setIsJoinedWaitList(false);
  };

  const [isJoinedWaitList, setIsJoinedWaitList] = useState(false);
  const [userDetails, setUserDetails] = useState(null);
  const [refLink, setRefLink] = useState(null);
  const [signupError, setSignupError] = useState("");
  const [copied, setCopied] = useState(false);
  const dispatch = useDispatch();
  const [open2, setOpen2] = useState(false);

  const handleRefralLink = (e) => {
    if (user.token) {
      const tagManagerArgs = {
        dataLayer: {
          event: "refralLinkModalopen",
          refLink: refLink,
          userStatus: "loggedIn",
        },
      };
      TagManager.dataLayer(tagManagerArgs);
    } else {
      const tagManagerArgs = {
        dataLayer: {
          event: "refralLinkModalopen",
          refLink: refLink,
          userStatus: "Guest",
        },
      };
      TagManager.dataLayer(tagManagerArgs);
    }
    e.stopPropagation();
    setOpen2(true);
  };

  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  const validateform = () => {
    const errors = {};
    if (!email) {
      errors.email = "Email id is required!";
      setFormErrors(errors);
      return false;
    } else {
      if (!validateEmail(email)) {
        errors.email = "Please enter valid email id!";
        setFormErrors(errors);
        return false;
      }
    }
    return true;
  };

  const { mutate: getUserLocation } = useMutation(
    () => fetcher.get(GEOLOCATION_URL),
    {
      onSuccess: (result) => {
        setLocation(result);
      },
      onError: (error) => {
        setLocation({});
      },
    }
  );

  // re-send verify email
  const [resentEmail, setResentEmail] = useState(false);

  const { mutate: resendVerifyEmail } = useMutation(
    (userId) =>
      fetcher.post(`/v1/auth/send-verification-email`, {
        userId,
      }),

    {
      onSuccess: (res) => {
        setResentEmail(true);
        setTimeout(() => {
          setResentEmail(false);
        }, 2 * 60 * 1000);
      },
      onError: (error) => {
        setResentEmail(false);
      },
    }
  );

  const onCaptchaChange = (value) => {};
  useEffect(() => {
    if (copied) {
      setTimeout(() => {
        setCopied(false);
      }, 500);
    }
  }, [copied]);

  const { mutate: getProfile } = useMutation(
    (id) => fetcher.get(`/v1/user/${profile?.id || id}`),
    {
      onSuccess: (response) => {
        dispatch(setUserData(response?.result));
        dispatch(
          setUserDetail({
            ...profile,
            referralId: response?.result?.referralId,
          })
        );
        setRefLink(`${WEB_URL}/?ic=${response?.result?.referralId?.refCode}`);
      },
      onError: (error) => {
        setNameUpdateError(true);
      },
    }
  );

  useEffect(() => {
    if (typeof window !== "undefined") {
      let userId = localStorage.getItem("userId");
      if (isEmpty(userId)) {
        setRefLink("Please login to get referal link");
      } else {
        setIsLoggedIn(true);
        getProfile(userId);
      }
    }
  }, []);

  const copyToClipboard = () => {
    navigator.clipboard.writeText(
      refLink +
        "\n" +
        "Get ₹50 on Signup and 20% Cashback using my referral link | Invest in Songs and Own Music | Earn multifold returns \n"
    );
    setCopied(true);
    if (user.token) {
      const tagManagerArgs = {
        dataLayer: {
          event: "refralLinkCopied",
          refLink: refLink,
          userStatus: "loggedIn",
        },
      };
      TagManager.dataLayer(tagManagerArgs);
    } else {
      const tagManagerArgs = {
        dataLayer: {
          event: "refralLinkCopied",
          refLink: refLink,
          userStatus: "Guest",
        },
      };
      TagManager.dataLayer(tagManagerArgs);
    }
  };

  const handleLogin = () => {
    eventBus.dispatch("openLoginModal", { function_name: "uniqueCommunity" });
  };
  return (
    <Box id="Refer" sx={accessStyle.joinAccessSection}>
      {isJoinedWaitList ? (
        <>
          <Box className={styles.boxContainer} style={{ width: "100%" }}>
            <Box
              sx={styles.modalCloseButton}
              onClick={handleClose}
              position="absolute"
            >
              <MdOutlineClose size={24} color="#000000" />
            </Box>

            <Box sx={styles.rankContainer}>
              <div style={styles.rankContainerInside}>
                <Typography
                  sx={{
                    ...styles.rankHeadingText,
                    marginLeft: "24px",
                  }}
                >
                  {"Current Rank"}
                </Typography>
                {/* <Typography
                    sx={{
                      ...styles.rankText,
                      fontSize:
                        userDetails.rank.toString().length > 4
                          ? "30px"
                          : "36px",
                      linHeight: "44px",
                    }}
                  >
                    {userDetails ? userDetails.rank : ""}
                  </Typography> */}
                <Typography
                  sx={{
                    ...styles.rankText,
                    fontSize: "36px",
                    linHeight: "44px",
                  }}
                >
                  {"  #90"}
                </Typography>
              </div>
            </Box>

            <Box sx={{ ...styles.waitListDescription }}>
              <Typography sx={styles.waitListText}>
                {" Refer more to move up the Leaderboard!"}
              </Typography>
              <Typography
                sx={{
                  ...styles.waitListText,
                  fontWeight: "400",
                  marginTop: "10px",
                }}
              >
                Do not forget, every time someone buys a Song NFT using your
                referral link, you will move up the leaderboard. Top 100
                Referers will get a Free Song NFT <br />
                <br />
                <br />
                Check your spot in line and grab your referral link.
              </Typography>
            </Box>
            <Box
              sx={{ ...styles.urlContainer, cursor: "pointer" }}
              onClick={copyToClipboard}
            >
              <Typography
                sx={{
                  width: "100%",
                  minWidth: "205px",
                  overflow: "hidden",
                  color: "#E14084",
                  whiteSpace: "nowrap",
                }}
              >
                {refLink}
              </Typography>
              <Box sx={styles.copyToClipboardContainer}>
                <Box sx={styles.copyToClipboardButton}>
                  {copied ? (
                    <Typography variant="h5" sx={styles.copied}>
                      Copied
                    </Typography>
                  ) : (
                    <IoCopyOutline size={24} color="#E14084" />
                  )}
                </Box>
              </Box>
            </Box>
            <Box sx={styles.dashline}></Box>
            <Box sx={styles.socialButtonsContainer}>
              <Typography
                sx={{
                  ...styles.waitListText,
                  fontWeight: "600",
                  fontSize: "18px",
                  marginBottom: "15px",
                  lineHeight: "27px",
                  color: "rgba(0, 0, 0, 0.75)",
                  textAlign: "center",
                }}
              >
                Share Now
              </Typography>
              {/* <SocialShareComponent shareLink={refLink} /> */}
            </Box>
            <Box
              sx={{
                position: "relative",
                margin: "15px auto 0",
                width: "100%",
                maxWidth: "675px",
                height: "42px",
              }}
            >
              <Typography variant="h5" sx={styles.bottomText}>
                For more updates, contests and giveaways, join our Community on
                <Link href="https://discord.gg/4asYZXT7FD" target="_blank">
                  {" "}
                  Discord.
                </Link>
              </Typography>
            </Box>
          </Box>
        </>
      ) : (
        <Box sx={accessStyle.dataContainer}>
          <Box className="title01 mx-auto d-block">
            <Box
              variant="h5"
              sx={accessStyle.mainTitle}
              id="exampleModalLongTitle"
            >
              Refer and Earn
            </Box>
          </Box>
          <Box className="join-waitlist-img">
            <Typography variant="h3" sx={accessStyle.limitedEdition}>
              Get Your Unique Referral Link
            </Typography>
            <Box
              sx={{ ...styles.urlContainer, cursor: "pointer" }}
              onClick={copyToClipboard}
            >
              <Typography
                style={{
                  width: "100%",
                  minWidth: "205px",
                  overflow: "hidden",
                  color: "#E14084",
                  whiteSpace: "nowrap",
                }}
              >
                {refLink}
              </Typography>
              <Box sx={styles.copyToClipboardContainer}>
                <Box sx={styles.copyToClipboardButton}>
                  {isLoggedIn ? (
                    <>
                      {copied ? (
                        <Typography variant="h5" sx={styles.copied}>
                          Copied
                        </Typography>
                      ) : (
                        <IoCopyOutline size={24} color="#E14084" />
                      )}
                    </>
                  ) : (
                    <></>
                  )}
                </Box>
              </Box>
            </Box>
            {isLoggedIn && (
              <Button
                variant="contained"
                style={{ width: "230px", margin: "auto", marginTop: "15px" }}
                sx={accessStyle.featuredBuyNow1}
                onClick={(e) => handleRefralLink(e)}
              >
                Share Referral Link
              </Button>
            )}
            {!isLoggedIn && (
              <Button
                variant="contained"
                onClick={() => handleLogin()}
                style={{ width: "230px", margin: "auto", marginTop: "15px" }}
                sx={accessStyle.featuredBuyNow1}
              >
                Share Referral Link
              </Button>
            )}
          </Box>
          <Box className="join-wait-form">
            <Typography variant="h3" sx={accessStyle.referIncentive}>
              Referral Incentive
            </Typography>
            <Typography sx={accessStyle.gettext}>
            1. Get INR 50 Referral Bonus every time when someone signs up using your referral link. Your friend will also get INR 50 Referral Bonus.
            </Typography>
            <Typography sx={accessStyle.gettext}>
            2. You will also get 20% Referral Bonus every time on the first NFT purchase of your friends when they sign up using your referral link. Your friend will also get 20% Cashback.
            </Typography>
            {/* <ol
              style={{
                color: "#FFF",
                paddingLeft: "60px",
                paddingRight: "20px",
              }}
              type="a"
            >
              <li>
                Top most referrer in leaderboard will get 1 Platinum NFT worth
                ₹40000 (around $500)
              </li>
              <li>
                Second most referrer will get 1 Gold NFT worth ₹4000 (around
                $50)
              </li>
              <li>
                Rest of the highest referrers will get 1 Silver NFT worth ₹800
                (around $10)
              </li>
            </ol> */}
            {/* <Typography sx={accessStyle.checkReferal}  onClick={()=>setIsJoinedWaitList(true)}>
                    Check your Referral rank in leaderboard
                </Typography> */}
            {/* <Typography sx={accessStyle.tandc} onClick={() => handleOpen1()}>
              {"Terms & Conditions Apply"}
            </Typography> */}
          </Box>
        </Box>
      )}

      {/* <Modal
        open={open}
        onClose={handleClose1}
        aria-labelledby="How It Works"
        aria-describedby="modal-modal-description"
      >
       <SocialShareComponent shareLink={refLink} />
      </Modal> */}

      <Modal
        open={open}
        onClose={handleClose1}
        aria-labelledby="How It Works"
        aria-describedby="modal-modal-description"
      >
        <Box sx={accessStyle.modalContainer}>
          <Box sx={accessStyle.modalHeader}>
            <Typography variant="h4" sx={accessStyle.modalTitle}>
              Terms & Conditions
            </Typography>
            <Typography
              variant="span"
              style={{ color: "#e04084", cursor: "pointer" }}
              onClick={handleClose1}
            >
              <i className="fa fa-times"></i>
            </Typography>
          </Box>
          <Box sx={accessStyle.modalBody}>
            <List sx={accessStyle.modalListContent} component="ol">
              {/* <ListItem>
                <Box component="p">
                User (Referred, Referee and buyer) will be eligible for cashback only on 1 song NFT
                </Box>
              </ListItem>
              <ListItem>
                <Box component="p">
                Cashback is applicable on first and only a single NFT purchase out of all NFT purchases by a user
                </Box>
              </ListItem> */}

              <ListItem>
                <Box component="p">
                  A user will be eligible for maximum referral bonus for upto
                  first 13 referrals.
                </Box>
              </ListItem>

              <ListItem>
                <Box component="p">
                  You and your friend both will get rewarded but only for your
                  friend’s first NFT purchase and only if they signup using your
                  referral link.
                </Box>
              </ListItem>

              <ListItem>
                <Box component="p">
                  Only new user referrals from 31st July, 2022 will be
                  considered eligible.
                </Box>
              </ListItem>

              <ListItem>
                <Box component="p">
                  Cashback will be disbursed in form of FanTiger Coins which can
                  be redeemed in future NFT purchases on FanTiger platform and
                  can be spend on other privileges.
                </Box>
              </ListItem>

              <ListItem>
                <Box component="p">
                  Each coin will be equal in value to 1 Paisa.
                </Box>
              </ListItem>

              <ListItem>
                <Box component="p">
                  Conditions may apply on application and redeemability of coins
                  and will be at the sole discretion of company.
                </Box>
              </ListItem>

              <ListItem>
                <Box component="p">
                  Leaderboard for top 100 referrers will be closing and winners
                  will get announced soon. So keep moving up the leaderboard by
                  doing more referrals.
                </Box>
              </ListItem>
            </List>
          </Box>
          <Box sx={accessStyle.modalFooter}></Box>
        </Box>
      </Modal>

      <ReCAPTCHA
        ref={recaptchaRef}
        size="invisible"
        sitekey={RECAPTCHA_SITE_KEY}
        onChange={onCaptchaChange}
      />
      <Modal open={open2} onClick={() => setOpen2(false)}>
        <SocialShareComponent
          style={{ left: "50%", top: "55%" }}
          nftLink={refLink}
          tokenType="refralLink"
        />
      </Modal>
    </Box>
  );
};

export default ReferAndEarn;
